<main id="content" role="main" class="main">
    <!-- Content -->
    <div class="content container">
        <div >
            <nav aria-label="breadcrumb">
                <ol id="w1" class="breadcrumb">
                    <li class="breadcrumb-item"><a href="/">{{'home'|translate}}</a></li>
                    <li class="breadcrumb-item active" aria-current="page">
                        {{'serviceOutput'|translate}}
                    </li>
                </ol>
            </nav>
        </div>
        <div id="create-form" class="row justify-content-center py-7" style="background:url(/img/bg-green-full.png);">
            <div class="col-md-8 col-12">
                <div dir="rtl" class="card">
                    <div class="card-header">
                        <h2 class="card-title h2"> 
                            {{'serviceOutput'|translate}}
                        </h2>
                    </div>

                    <div class="card-body">

    <!-- IF DATA EXISTS -->
    <ng-container *ngIf="outputs && outputs.length > 0; else noData">

        <div class="row" *ngFor="let item of outputs">
            
            <div class="col-md-6 mb-4" *ngIf="item.note">
                <label>
                    {{item.note}}
                </label>
            </div>

            <div class="col-sm-6 mb-4" *ngIf="item.file">
                <div role="button" (click)="downloadMinioFile(item.file)" class="text-primary">
                    تنزيل
                    <i class="fa fa-download"></i>
                </div>
            </div>

        </div>

    </ng-container>

    <!-- NO DATA TEMPLATE -->
    <ng-template #noData>
        <div class="text-center py-4">
            {{ 'noResultsFound' | translate }}
        </div>
    </ng-template>




                        

                       

                        
                    </div>
                </div>
            </div>  
        </div>
    </div>
</main>
